// extracted by mini-css-extract-plugin
export default {"container":"bienestar_container__vMMtn"};